import { api } from '@/shared/api/client';

interface CompletionRequestItem {
  content: {
    id?: string;
    title?: string;
  };
  course: {
    id?: string;
    title?: string;
  };
  claimed_completion_datetime?: string;
}

interface PostContentCompletionRequest {
  items: CompletionRequestItem[];
  additional_information?: string;
}

export const postContentCompletionRequest = async (
  payload: PostContentCompletionRequest
) => {
  const { data } = await api.post(
    '/course-content-completion-requests/',
    payload
  );
  return data;
};
